import React, {FC, useMemo} from 'react';
import {useTranslation} from 'gatsby-plugin-react-i18next';
import {FieldValues} from 'react-hook-form';
import {SocialNetworkSource} from '@src/Store/Slices/AppSlice/auth.slice';
import useBreakpoint from 'design-system/src/WebComponent/Grid/hooks/useBreakpoint';
import {Form} from '@src/Api/Umbraco/interface/UmbracoTypes';
import SignUpFormLoader from './components/SignUpFormLoader';
import {filterFormFields} from './utils/filterFormFields.util';
import SignUpFormContent from './components/SignUpFormContent';

export interface SignUpFormProps {
  onSubmit: (formData: any) => Promise<boolean>;
  initialValues: FieldValues;
  socialNetworkSource: SocialNetworkSource;
  form: Form | undefined;
  isLoading: boolean;
}

const SignUpForm: FC<SignUpFormProps> = ({
  initialValues,
  socialNetworkSource,
  form,
  isLoading,
  onSubmit,
}) => {
  const {isMobile} = useBreakpoint();
  const {t} = useTranslation('auth');

  const filteredForm = useMemo<Form | null>(
    () => filterFormFields(form, socialNetworkSource),
    [form, socialNetworkSource],
  );

  return filteredForm ? (!isLoading ? (
    <SignUpFormContent
      isMobile={isMobile}
      t={t}
      filteredForm={filteredForm}
      initialValues={initialValues}
      onSubmit={onSubmit}
    />
  ): <SignUpFormLoader />) : null;
};

export default SignUpForm;
